import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './language';
import { LanguageService } from './language.service';
import { fadeInAnimation } from '../../animations/fade-in.animation';


export class LanguageSelectorComponent implements OnInit {
  
  languages: Language[];
  languageSelected: Language;

  constructor(
    private languageService: LanguageService,
    private translate: TranslateService) { }

  ngOnInit() {
    if (!this.languages || this.languages.length === 0) {
      this.languageService.getData().subscribe(data => {
        this.languages = data;
        this.languageSelected = this.getInitialLanguageSelected();
        this.saveLanguage(this.languageSelected);
      });
    }
  }

  private getInitialLanguageSelected() {
    let initialLanguage : Language | null = this.getLanguageFromLocalStorage(localStorage['language']);
    if (initialLanguage == null) {
      initialLanguage = this.getDefaultLanguage();
    }
    return initialLanguage;
  }

  private getDefaultLanguage() {
    return this.languageSelected = this.languages[0];
  }

  private getLanguageFromLocalStorage(languageId : string) : Language | null {
    if (languageId == null) {
      return null;
    }
    let languageFound = null;
    this.languages.forEach((lang : Language) => {
      if (languageId === lang.id) {
        languageFound = lang;
        return;
      }
    });
    return languageFound;
  }

  onLanguageChange(language : Language) {
    console.log('... language changed to: ' + language);
    this.translate.use(language.id);
    this.saveLanguage(language);
    this.languageSelected = language;
  }

  private saveLanguage(language : Language) : void {
    if (localStorage) {
      localStorage['language'] = language.id;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'leaf-language-selector',
  template: `
  <div class="btn-group" dropdown *ngIf="languageSelected" [@fadeInAnimation]>
    <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
      <i class="flag-icon flag-icon-squared {{languageSelected.icon}}" style="border: 2px solid #fff; border-radius: 50%; width: 22px; height: 22px;"></i>&nbsp; {{languageSelected.title}} <span class="caret"></span>
    </button>
    <ul *dropdownMenu class="dropdown-menu" role="menu">
      <li role="menuitem" *ngFor="let lang of languages" (click)="onLanguageChange(lang)">
          <a class="dropdown-item"><i class="flag-icon {{lang.icon}}"></i>&nbsp; {{lang.title}}</a>
      </li>
    </ul>
  </div>
  `,
  animations: [fadeInAnimation]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LanguageService, },
{type: TranslateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'languages': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
